export const STAFF_NAVIGATION_PARAMS = ['_features', '_tracing'] as const

export function preserveStaffNavigationParams(search: string): string {
  const currentSearchParams = new URLSearchParams(window.location.search)
  const destinationSearchParams = new URLSearchParams(search)
  let modified = false

  for (const param of STAFF_NAVIGATION_PARAMS) {
    const currentValue = currentSearchParams.get(param)
    if (currentValue && !destinationSearchParams.has(param)) {
      destinationSearchParams.set(param, currentValue)
      modified = true
    }
  }

  if (!modified) return search

  const preservedSearch = destinationSearchParams.toString()
  return preservedSearch ? `?${preservedSearch}` : ''
}
